import { Component } from '@angular/core';
import { TColumn } from '@lib/modules/table/components';
import { SharedSendMoneyModule } from '../components/send-money/shared-send-money.module';
import { SharedSendMoneyComponent } from '../components/send-money/shared-send-money.component';
import { BeneficiarySelectionComponent } from './components/beneficiary-selection/beneficiary-selection.component';

@Component({
    standalone: true,
    selector: 'app-send-money',
    templateUrl: './send-money.component.html',
    styleUrls: ['./send-money.component.scss'],
    imports: [SharedSendMoneyModule],
})
export class SendMoneyComponent extends SharedSendMoneyComponent {
    public override ngOnInit(): void {
        super.ngOnInit();
        this.columns = [{ transaction_timestamp: 'Date Transferred' }, { transaction_type: 'Type' }, { sender: 'Sender' }, { receiver_name: 'Receiver Name' }, { amount_received: 'Amount Received' }, { transfer_status: 'Transfer Status' }];
        this.defaultColumns = ['transaction_timestamp', 'transaction_type', 'sender', 'receiver_name', 'amount_received', 'transfer_status'];
        this.redirectToComponent = BeneficiarySelectionComponent;
    }
}
